import { render, staticRenderFns } from "./berth.vue?vue&type=template&id=dd764eee"
import script from "./berth.vue?vue&type=script&lang=js"
export * from "./berth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports